<template>
  <div class="top-bar-wrap">
    <div :class="isAuthenticated ? 'topbar auth' : 'topbar'">

      <!-- LOGIN UNAUTHENTICATED -->
      <CustomMenubar v-if="!isAuthenticated && !isLoading" />
      <!-- LOGIN WITHOUT SELECTED FEATURE -->
      <CustomMenubar v-if="isHomePage && isAuthenticated && userRole !== 'EnterpriseAdmin'" :user="user" />
      <!-- LOGIN WITH SELECTED FEATURE - VINSCANNER -->
      <CustomMenubar v-if="isVINScannerPage && isAuthenticated" :model="vinscannerTabs" :user="user" />
      <!-- LOGIN WITH SELECTED FEATURE - DVI -->
      <CustomMenubar v-if="isDVIPage && isAuthenticated" :model="DVITabs" :user="user" />
      <!-- LOGIN WITH SELECTED FEATURE - REPORTING -->
      <CustomMenubar v-if="isReportingPage && isAuthenticated" :model="ReportingTabs" :user="user" />
      <!-- ENTERPRISE REPORT PAGE -->
      <CustomMenubar v-if="isEnterpriseReportPage && isAuthenticated" :model="EnterpriseReportTabs" :user="user" />
      <!-- HOME PAGE LOGIN AS ENTERPRISE ADMIN -->
      <CustomMenubar v-if="isHomePage && isAuthenticated && userRole === 'EnterpriseAdmin' && !store.state.isStoreLogin" :user="user" />

      <CustomMenubar v-if="isHomePage && isAuthenticated && userRole === 'EnterpriseAdmin' && store.state.isStoreLogin" :model="EnterpriseReportTabs" :user="user" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import CustomMenubar from './CustomMenubar.vue';
import { useStore } from 'vuex';

const store = useStore();
const auth0 = useAuth0();
const router = useRouter();
const isAuthenticated = ref(auth0.isAuthenticated);
const isLoading = ref(auth0.isLoading);
const user = ref(auth0.user);
const userRole = computed(() => {
  if (!user.value) return null
  return user.value['http://protractor.com/role'] || null
});

const homeLabel = computed(() => {
  return userRole.value === 'EnterpriseAdmin' ? 'Store Home' : 'Home'
});

/**
 * List of tabs for VINScanner
 */
const vinscannerTabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Work Orders',
    path: '/workorders'
  }
]);

/**
 * List of tabs for DVI
 */
const DVITabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Work Orders',
    path: '/dviworkorders'
  },
]);

const ReportingTabs = ref([
  {
    label: homeLabel,
    path: '/'
  },
  {
    label: 'Dashboard',
    path: '/reporting'
  },
  {
    label: 'Reports',
    path: '/reports'
  }
]);

const EnterpriseReportTabs = ref([
  {
    label: 'Enterprise Home',
    path: '/'
  }
]);

const dvipages = ['/dviworkorders', '/dviworkorderpackages', '/dviupdateworkorderpackage', '/dvisummaryworkorderpackage'];
const vinscannerpages = ['/workorders', '/updateorder'];
const reportingpages = ['/reporting', '/reports', '/reports2'];
const enterprisereportpages = ['/enterprise'];

const isHomePage = computed(() => router.currentRoute.value.path === '/');
const isVINScannerPage = computed(() => vinscannerpages.includes(router.currentRoute.value.path));
const isDVIPage = computed(() => dvipages.includes(router.currentRoute.value.path));
const isReportingPage = computed(() => reportingpages.includes(router.currentRoute.value.path));
const isEnterpriseReportPage = computed(() => enterprisereportpages.includes(router.currentRoute.value.path));

</script>
